import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom"; // ⬅ add useNavigate
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { useAuth } from "../auth/AuthProvider"; // ⬅ // inside your sidebar/menu component



const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user, profile } = useAuth();  

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px";
        }
      });

      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`;
        }
      }
    };

    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            }
          }
        });
      });
    };

    openActiveDropdown();

    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  // ⬇⬇⬇ NEW: logout handler
  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();                    // from AuthProvider
    } finally {
      navigate("/sign-in", { replace: true }); // go to sign-in either way
    }
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/' className='sidebar-logo d-flex align-items-center gap-2'>
            <img
              src='/assets/images/logo.png'
              alt='RideWatch'
              style={{ height: '40px', width: 'auto' }}
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            {/* Super Admin Menu - Only visible to super_admin users */}
            {profile?.role === 'super_admin' ? (
              <>
                <li className="sidebar-menu-group-title">Super Admin</li>
                <li>
                  <NavLink
                    to='/admin/users'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mdi:shield-account' className='menu-icon' />
                    <span>User Management</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/admin/subscriptions'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mdi:credit-card-check' className='menu-icon' />
                    <span>Subscriptions</span>
                  </NavLink>
                </li>
              </>
            ) : (
              <>
                <li>
                  <NavLink
                    to='/'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon
                      icon='solar:home-smile-angle-outline'
                      className='menu-icon'
                    />
                    <span>Dashboard</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/live-map'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mdi:map-marker-radius-outline' className='menu-icon' />
                    <span>Live Bus Map</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/schools'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mdi:school-outline' className='menu-icon' />
                    <span>Schools</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/invite-driver'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mdi:email-plus-outline' className='menu-icon' />
                    <span>Invite Driver</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/driver-list'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mdi:account-group' className='menu-icon' />
                    <span>Driver List</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/routes'
                    className={(navData) => (navData.isActive ? "active-page" : "")}
                  >
                    <Icon icon='mdi:bus-school' className='menu-icon' />
                    <span>Driver Routes</span>
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
                <form className='navbar-search'>
                  <input type='text' name='search' placeholder='Search' />
                  <Icon icon='ion:search-outline' className='icon' />
                </form>
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                <ThemeToggleButton />

                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                    style={{
                      width: '40px',
                      height: '40px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      border: 'none'
                    }}
                  >
                    <Icon
                      icon='mdi:account'
                      style={{ fontSize: '24px', color: 'white' }}
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          {user?.displayName || profile?.displayName || 'User'}
                        </h6>
                        <span className='text-secondary-light fw-medium text-sm'>
                          {user?.email || ''}
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      <li>
                        {/* changed from Link to button to call logout */}
                        <button
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3 w-100 text-start'
                          onClick={handleLogout}
                          type='button'
                        >
                          <Icon icon='lucide:power' className='icon text-xl' />
                          Log Out
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© 2026 RideWatch. All Rights Reserved.</p>
            </div>
            <div className='col-auto'>
              <p className='mb-0'>
                <span className='text-primary-600'>School Bus Tracking System</span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
